// Web Audio synth ported from the legacy game: short tones, no assets.

let enabled = localStorage.getItem('soundEnabled') !== 'false';
let ctx: AudioContext | null = null;

function audio(): AudioContext {
  ctx ??= new AudioContext();
  return ctx;
}

function tone(frequency: number, duration: number, type: OscillatorType = 'sine', volume = 0.3): void {
  if (!enabled) return;
  try {
    const a = audio();
    const osc = a.createOscillator();
    const gain = a.createGain();
    osc.connect(gain);
    gain.connect(a.destination);
    osc.frequency.value = frequency;
    osc.type = type;
    gain.gain.setValueAtTime(volume, a.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.01, a.currentTime + duration);
    osc.start(a.currentTime);
    osc.stop(a.currentTime + duration);
  } catch {
    /* audio unavailable */
  }
}

export const sound = {
  get enabled(): boolean {
    return enabled;
  },
  toggle(): boolean {
    enabled = !enabled;
    localStorage.setItem('soundEnabled', String(enabled));
    if (enabled) this.click();
    return enabled;
  },
  click(): void {
    tone(600, 0.08, 'sine', 0.2);
  },
  tick(): void {
    tone(800, 0.05, 'square', 0.1);
  },
  win(): void {
    tone(523.25, 0.15);
    setTimeout(() => tone(659.25, 0.15), 100);
    setTimeout(() => tone(783.99, 0.3), 200);
  },
  lose(): void {
    tone(392, 0.2, 'sawtooth', 0.2);
    setTimeout(() => tone(349.23, 0.3, 'sawtooth', 0.2), 150);
  },
  achievement(): void {
    tone(523.25, 0.1);
    setTimeout(() => tone(659.25, 0.1), 100);
    setTimeout(() => tone(783.99, 0.1), 200);
    setTimeout(() => tone(1046.5, 0.4, 'sine', 0.4), 300);
  },
};
